import React, { Component } from 'react';
import './index.css';


class HTMLSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: this.props.selectedItem ? this.props.selectedItem : this.props.options ? this.props.options[0] : null ,
      showDialog: false
    }
    this.titleClickHandler = this.titleClickHandler.bind(this);
    this.selsctClickHandler = this.selsctClickHandler.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  titleClickHandler(e) {
    this.setState({ showDialog: !this.state.showDialog });
  }

  selsctClickHandler(selectedItem) {
    this.setState({ selectedItem, showDialog: false });
    if(selectedItem !== this.state.selectedItem) {this.props.onChange(selectedItem)}
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ showDialog: false })
    }
  }

  componentWillReceiveProps(newProps){
    if(this.props.options && newProps.options[0] !== this.props.options[0]){
      this.setState({selectedItem:newProps.selectedItem ? newProps.selectedItem : newProps.options[0]})
    }
    if(this.props.reset && newProps.reset !== this.props.reset){
      this.setState({selectedItem:newProps.selectedItem ? newProps.selectedItem : newProps.options[0]})
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }



  render() {
    const { options, optionsClass, selectClass, className, titleClass, textClass, bgColor, selColor, lang } = this.props;
    const { selectedItem, showDialog } = this.state;
    return (
      <div ref={this.setWrapperRef} className={className ? className + ' html-select-container' : 'html-select-container'} style={{direction:lang==='fa' ? 'rtl' :'ltr'}}>
        <div className={titleClass ? titleClass + ' html-select-title-container' : 'html-select-title-container'}>
          <div className='html-select-title' onClick={this.titleClickHandler} style={{backgroundColor:bgColor ? bgColor :''}}>
            <div>{selectedItem ? selectedItem : null}</div>
            { showDialog ? <span style={{marginLeft:'2px'}} className="bp3-icon bp3-icon-caret-up"></span>
              :<span style={{marginLeft:'2px'}} className="bp3-icon bp3-icon-caret-down"></span>
            }
          </div>
        </div>
        {
          showDialog && <ul className={selectClass ? selectClass + ' html-select-options-container' : 'html-select-options-container'}>
            {options.map((item, index) => {
              return (
                <li 
                  key={item + index}
                  style={{backgroundColor:selectedItem === item ? 'rgb(241, 241, 241)' : '', color: selectedItem === item ? selColor ? selColor : '': ''}}
                  className={optionsClass ? optionsClass + ' html-select-option' : 'html-select-option'} 
                  onClick={() => this.selsctClickHandler(item)}>
                  {selectedItem === item ? <span className="bp3-icon bp3-icon-small-tick"></span>
                    : <span style={{ visibility: 'hidden' }} className="bp3-icon bp3-icon-small-tick"></span>
                  }
                  <span className={textClass ? textClass + ' html-select-text' : 'html-select-text'}>{item ? item : ''}</span>
                </li>
              )
            })
            }
          </ul>
        }
      </div>
    );
  }
}

export default HTMLSelect;